import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieConsent from '../../components/feature/CookieConsent';
import FloatingButtons from '../../components/feature/FloatingButtons';

const HomePage = () => {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.');

  useEffect(() => {
    document.title = 'İzmir Tente Tamir - Profesyonel Tente Tamiri ve Yenileme Hizmetleri';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir Tente Tamir, Karabağlar ve İzmir genelinde tente tamiri, körüklü tente, mafsallı tente, branda değişimi ve motorlu tente servisi sunar. Hızlı ve kaliteli hizmet için 0551 372 35 12');
    }
  }, []);

  const services = [
    {
      title: 'Tente Tamiri',
      description: 'Her türlü tente arızası için profesyonel tamir hizmeti sunuyoruz.',
      icon: 'ri-tools-line',
      link: '/hizmetler/tente-tamiri',
      image: 'https://public.readdy.ai/ai/img_res/83be1c70f9dc1ddac8e342a843b8f34c.jpg'
    },
    {
      title: 'Körüklü Tente Tamiri',
      description: 'Körüklü tente sistemlerinin bakım, onarım ve yenileme işlemleri.',
      icon: 'ri-building-line',
      link: '/hizmetler/koruklu-tente-tamiri',
      image: 'https://readdy.ai/api/search-image?query=accordion%20style%20folding%20awning%20canopy%20system%20on%20a%20storefront%2C%20retractable%20pleated%20shade%20structure%2C%20modern%20commercial%20building%20facade%2C%20clean%20professional%20photography%2C%20bright%20natural%20light%2C%20white%20and%20gray%20tones&width=400&height=300&seq=home_svc2&orientation=landscape'
    },
    {
      title: 'Mafsallı Tente Tamiri',
      description: 'Mafsallı tente mekanizmalarının tamiri ve bakımı.',
      icon: 'ri-home-gear-line',
      link: '/hizmetler/mafsalli-tente-tamiri',
      image: 'https://readdy.ai/api/search-image?query=articulated%20arm%20retractable%20awning%20on%20a%20residential%20balcony%2C%20folding%20arm%20mechanism%20visible%2C%20modern%20apartment%20building%2C%20clean%20fabric%20canopy%20extended%20over%20terrace%2C%20professional%20architectural%20photography%2C%20daylight&width=400&height=300&seq=home_svc3&orientation=landscape'
    },
    {
      title: 'Branda Değişimi',
      description: 'Eski ve yıpranmış brandalarınızı kaliteli malzemelerle yeniliyoruz.',
      icon: 'ri-refresh-line',
      link: '/hizmetler/branda-degisimi',
      image: 'https://readdy.ai/api/search-image?query=heavy%20duty%20tarpaulin%20canvas%20fabric%20replacement%20on%20commercial%20awning%20structure%2C%20new%20clean%20white%20fabric%20being%20installed%2C%20professional%20workmanship%2C%20outdoor%20setting%2C%20bright%20daylight%2C%20industrial%20quality%20material&width=400&height=300&seq=home_svc4&orientation=landscape'
    },
    {
      title: 'Tente Yenileme',
      description: 'Eskiyen tentelerinize yepyeni bir görünüm kazandırıyoruz.',
      icon: 'ri-recycle-line',
      link: '/hizmetler/tente-yenileme',
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20awning%20renovation%2C%20refreshed%20clean%20canopy%20on%20modern%20cafe%20exterior%2C%20renewed%20fabric%20shade%20structure%2C%20bright%20and%20vibrant%20colors%2C%20professional%20restoration%20work%2C%20commercial%20building%20facade%2C%20daylight%20photography&width=400&height=300&seq=home_svc5&orientation=landscape'
    },
    {
      title: 'Motorlu Tente Servisi',
      description: 'Manuel ve motorlu tente sistemleri için servis ve bakım.',
      icon: 'ri-settings-3-line',
      link: '/hizmetler/manuel-motorlu-tente-servisi',
      image: 'https://readdy.ai/api/search-image?query=motorized%20electric%20retractable%20awning%20system%20with%20remote%20control%2C%20automatic%20canopy%20mechanism%20on%20luxury%20home%20terrace%2C%20modern%20technology%20shade%20solution%2C%20clean%20professional%20photography%2C%20bright%20daylight%20setting&width=400&height=300&seq=home_svc6&orientation=landscape'
    }
  ];

  const stats = [
    { number: '500+', label: 'Tamamlanan Proje' },
    { number: '15+', label: 'Yıllık Deneyim' },
    { number: '%100', label: 'Müşteri Memnuniyeti' },
    { number: '7/24', label: 'Destek Hizmeti' }
  ];

  const references = [
    { name: 'Mehmet Yılmaz', text: 'İzmir Tente Tamir ile çalışmak gerçekten keyifliydi. İşlerini profesyonelce yapıyorlar.', location: 'Karabağlar' },
    { name: 'Ayşe Demir', text: 'Hızlı ve kaliteli hizmet aldık. Tentelerimiz yepyeni görünüyor. Teşekkürler.', location: 'Bornova' },
    { name: 'Ali Kaya', text: 'Fiyatları uygun, işçilikleri temiz. Kesinlikle tavsiye ediyorum.', location: 'Buca' },
    { name: 'Fatma Çelik', text: 'Motorlu tente sistemimizi kısa sürede tamir ettiler. Çok memnunuz.', location: 'Konak' },
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f4f1ec', fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <CookieConsent />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="pt-20 pb-10 md:pt-24 md:pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div>
              <div className="inline-block px-3 py-1.5 rounded-full mb-4" style={{ backgroundColor: '#e8e3d9' }}>
                <span className="text-xs font-medium text-gray-700">İzmir&apos;in Güvenilir Tente Tamircisi</span>
              </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
                İzmir Tente Tamir
              </h1>
              <p className="text-sm md:text-base text-gray-600 mb-6 leading-relaxed">
                Konutlardan ticari alanlara kadar geniş bir yelpazede profesyonel <strong>izmir tente tamir</strong>, yenileme ve gölgelendirme sistemleri hizmetleri sunuyoruz.
              </p>
              <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-3">
                <a
                  href="tel:+905513723512"
                  className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-xs font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                >
                  Hemen Ara
                </a>
                <a
                  href={`https://wa.me/905513723512?text=${whatsappMessage}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-xs font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                >
                  WhatsApp&apos;tan Yaz
                </a>
                <a
                  href="tel:+905513723512"
                  className="px-5 py-2.5 border-2 border-gray-300 hover:bg-gray-50 text-gray-700 text-xs font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                >
                  Ücretsiz Keşif İçin Ara
                </a>
              </div>
            </div>
            <div className="relative">
              <div className="bg-gray-50 rounded-2xl shadow-xl overflow-hidden w-full h-64 md:h-80 lg:h-96">
                <img
                  src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/f81d688a853c5a7bd9512156b67df331.jpeg"
                  alt="Profesyonel İzmir Tente Tamir"
                  className="w-full h-full object-cover object-top"
                  loading="eager"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#f4f1ec' }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">Hizmetlerimiz</span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-2 mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Profesyonel Tente Çözümleri
            </h2>
            <p className="text-sm text-gray-600 max-w-2xl mx-auto">
              İzmir genelinde her türlü tente ihtiyacınız için kaliteli ve güvenilir hizmet sunuyoruz
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5" data-product-shop>
            <Link to="/hizmetler/tente-tamiri" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20awning%20repair%20service%20worker%20fixing%20striped%20fabric%20canopy%20on%20building%20exterior%2C%20close-up%20of%20hands%20working%20with%20tools%2C%20clean%20simple%20background%2C%20bright%20daylight%2C%20high%20quality%20service%20photography&width=300&height=250&seq=hg1&orientation=landscape"
                  alt="Tente Tamiri"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Profesyonel tamir hizmeti</p>
            </Link>

            <Link to="/hizmetler/koruklu-tente-tamiri" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=corrugated%20folding%20awning%20system%20on%20storefront%2C%20accordion%20style%20retractable%20canopy%2C%20modern%20commercial%20building%2C%20clean%20simple%20background%2C%20professional%20installation%2C%20bright%20daylight&width=300&height=250&seq=hg2&orientation=landscape"
                  alt="Körüklü Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Körüklü Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Bakım ve onarım</p>
            </Link>

            <Link to="/hizmetler/mafsalli-tente-tamiri" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=articulated%20arm%20awning%20with%20mechanical%20joints%20extended%20over%20patio%2C%20modern%20retractable%20system%2C%20clean%20simple%20background%2C%20residential%20setting%2C%20bright%20daylight%2C%20quality%20craftsmanship&width=300&height=250&seq=hg3&orientation=landscape"
                  alt="Mafsallı Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Mafsallı Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Kurulum ve bakım</p>
            </Link>

            <Link to="/hizmetler/branda-degisimi" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=worker%20replacing%20awning%20fabric%20canvas%20with%20new%20material%2C%20hands%20installing%20fresh%20striped%20canopy%2C%20clean%20simple%20background%2C%20professional%20service%2C%20bright%20daylight%2C%20quality%20materials&width=300&height=250&seq=hg4&orientation=landscape"
                  alt="Branda Değişimi"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Branda Değişimi</h3>
              <p className="text-xs text-gray-600 hidden md:block">Kaliteli malzeme</p>
            </Link>

            <Link to="/hizmetler/tente-yenileme" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=before%20and%20after%20awning%20renovation%2C%20old%20canopy%20being%20replaced%20with%20modern%20new%20system%2C%20clean%20simple%20background%2C%20transformation%20concept%2C%20bright%20daylight%2C%20professional%20upgrade&width=300&height=250&seq=hg5&orientation=landscape"
                  alt="Tente Yenileme"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Tente Yenileme</h3>
              <p className="text-xs text-gray-600 hidden md:block">Modern sistemler</p>
            </Link>

            <Link to="/hizmetler/manuel-motorlu-tente-servisi" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=motorized%20awning%20with%20electric%20motor%20and%20remote%20control%2C%20automated%20retractable%20canopy%20system%2C%20clean%20simple%20background%2C%20modern%20technology%2C%20bright%20daylight%2C%20smart%20home%20integration&width=300&height=250&seq=hg6&orientation=landscape"
                  alt="Manuel ve Motorlu Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Manuel ve Motorlu Tente Servisi</h3>
              <p className="text-xs text-gray-600 hidden md:block">Kurulum ve bakım</p>
            </Link>

            <Link to="/hizmetler/bioklimatik-pergola-tente" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20bioclimatic%20pergola%20with%20adjustable%20louvers%20on%20terrace%2C%20aluminum%20slats%20roof%20system%2C%20clean%20simple%20background%2C%20luxury%20outdoor%20living%2C%20bright%20daylight%2C%20contemporary%20architecture&width=300&height=250&seq=hg7&orientation=landscape"
                  alt="Bioklimatik Pergola"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Bioklimatik Pergola Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Akıllı havalandırma</p>
            </Link>

            <Link to="/hizmetler/otomatik-pergola-tente" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=automatic%20motorized%20pergola%20with%20retractable%20roof%20on%20patio%2C%20electric%20opening%20system%2C%20clean%20simple%20background%2C%20modern%20outdoor%20space%2C%20bright%20daylight%2C%20smart%20automation&width=300&height=250&seq=hg8&orientation=landscape"
                  alt="Otomatik Pergola"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Otomatik Pergola Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Motorlu sistem</p>
            </Link>

            <Link to="/hizmetler/kasetli-tente" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=cassette%20awning%20with%20protective%20housing%20box%20mounted%20on%20wall%2C%20enclosed%20retractable%20canopy%20system%2C%20clean%20simple%20background%2C%20modern%20design%2C%20bright%20daylight%2C%20weather%20protection&width=300&height=250&seq=hg9&orientation=landscape"
                  alt="Kasetli Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Kasetli Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Koruyucu kaset</p>
            </Link>

            <Link to="/hizmetler/t-modul-tente" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=T-module%20awning%20system%20with%20vertical%20drop%20fabric%20on%20storefront%2C%20modular%20canopy%20design%2C%20clean%20simple%20background%2C%20commercial%20application%2C%20bright%20daylight%2C%20modern%20architecture&width=300&height=250&seq=hg10&orientation=landscape"
                  alt="T-Modül Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">T-Modül Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Modüler tasarım</p>
            </Link>

            <Link to="/hizmetler/zip-perde-tente" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=zip%20screen%20awning%20with%20side%20rails%20and%20zippered%20edges%2C%20vertical%20roller%20blind%20system%2C%20clean%20simple%20background%2C%20windproof%20design%2C%20bright%20daylight%2C%20modern%20exterior&width=300&height=250&seq=hg11&orientation=landscape"
                  alt="Zip Perde Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Zip Perde Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Rüzgar dayanıklı</p>
            </Link>

            <Link to="/hizmetler/seffaf-stor-tente" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=transparent%20clear%20roller%20blind%20awning%20on%20balcony%2C%20see-through%20PVC%20screen%20system%2C%20clean%20simple%20background%2C%20weather%20protection%20with%20view%2C%20bright%20daylight%2C%20modern%20residential&width=300&height=250&seq=hg12&orientation=landscape"
                  alt="Şeffaf Stor Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Şeffaf Stor Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Görüş korumalı</p>
            </Link>

            <Link to="/hizmetler/fermuar-seffaf-tente" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=zippered%20transparent%20awning%20enclosure%20for%20terrace%2C%20clear%20PVC%20panels%20with%20zipper%20system%2C%20clean%20simple%20background%2C%20all-weather%20protection%2C%20bright%20daylight%2C%20outdoor%20living&width=300&height=250&seq=hg13&orientation=landscape"
                  alt="Fermuarlı Şeffaf Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Fermuarlı Şeffaf Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Fermuarlı sistem</p>
            </Link>

            <Link to="/hizmetler/fransiz-tente" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=French%20style%20curved%20awning%20with%20elegant%20scalloped%20valance%20on%20cafe%2C%20classic%20dome%20canopy%20design%2C%20clean%20simple%20background%2C%20traditional%20architecture%2C%20bright%20daylight%2C%20vintage%20charm&width=300&height=250&seq=hg14&orientation=landscape"
                  alt="Fransız Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Fransız Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Klasik tasarım</p>
            </Link>

            <Link to="/hizmetler/karpuz-tente" className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden mb-2 md:mb-3 w-full h-32 md:h-40" style={{ backgroundColor: '#ede8e0' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=watermelon%20style%20curved%20awning%20with%20rounded%20dome%20shape%20on%20window%2C%20semicircular%20canopy%20design%2C%20clean%20simple%20background%2C%20decorative%20exterior%2C%20bright%20daylight%2C%20charming%20architecture&width=300&height=250&seq=hg15&orientation=landscape"
                  alt="Karpuz Tente"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-900 mb-1">Karpuz Tente Tamiri</h3>
              <p className="text-xs text-gray-600 hidden md:block">Dekoratif model</p>
            </Link>
          </div>

          <div className="text-center mt-8 md:mt-10">
            <Link
              to="/hizmetler"
              className="inline-flex items-center px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-xs font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Tüm Hizmetler
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* SEO Article Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#ede8e0' }}>
        <div className="max-w-4xl mx-auto">

          {/* Intro */}
          <div className="mb-12">
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              İzmir gibi güneşin yoğun olduğu şehirlerde tente sistemleri hem konfor hem de mekanların kullanım alanını genişletmek açısından önemli bir rol oynar. Evler, işletmeler, kafeler ve restoranlar tente sistemleri sayesinde açık alanlarını daha verimli kullanabilir. Ancak zamanla rüzgar, güneş, yağmur ve mekanik kullanım nedeniyle tentelerde çeşitli arızalar oluşabilir. Bu noktada profesyonel bir <strong>izmir tente tamir</strong> hizmeti almak oldukça önemlidir.
            </p>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              Tecrübeli ekip ve doğru ekipman kullanımı, tente sistemlerinin uzun ömürlü olmasını sağlar. Yapılan işlemlerde tente kumaşı, mekanik sistem ve motor aksamı dikkatle incelenir. Böylece arızanın kaynağı doğru şekilde tespit edilir ve gereksiz işlemlerden kaçınılır.
            </p>
          </div>

          {/* H2 - Firmalar */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              İzmir Tente Tamir Firmaları (2026)
            </h2>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Son yıllarda dış mekan kullanımının artmasıyla birlikte tente sistemlerine olan talep de önemli ölçüde yüksmiştir. Bu durum, İzmir&apos;de <strong>tente tamiri izmir</strong> hizmeti veren firma sayısının da artmasına neden olmuştur. Ancak her firma aynı kalite ve profesyonellik standartlarını sunmayabilir.
            </p>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Tente sistemleri mekanik parçalar içerdiği için yapılan işlemlerin uzman kişiler tarafından gerçekleştirilmesi gerekir. Yanlış yapılan bir müdahale sistemin tamamen kullanılamaz hale gelmesine neden olabilir. Bu nedenle deneyimli bir ekip ile çalışmak büyük avantaj sağlar.
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <h4 className="text-sm font-semibold text-gray-900 mb-3">Tente tamir hizmetlerinde uygulanan işlemler:</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Tente mekanizması arıza tespiti</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Kumaş yenileme veya onarım</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Motorlu tente sistemleri bakımı</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Mekanik parça değişimi</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Tente ayar ve bakım işlemleri</span></li>
              </ul>
            </div>
          </div>

          {/* H2 - Hizmet Alanları */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              İzmir&apos;de Hangi Alanlarda Hizmet Veriyoruz?
            </h2>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Tente sistemleri yalnızca evlerde değil, birçok ticari işletmede de aktif olarak kullanılmaktadır. Özellikle restoranlar, kafeler, mağazalar ve oteller tente sistemleri sayesinde dış mekanlarını daha konforlu hale getirebilir. Bu nedenle <strong>izmir tente sistemleri tamiri</strong> hizmetleri oldukça geniş bir kullanım alanına sahiptir.
            </p>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Tente sistemlerinde zamanla kumaş deformasyonu, mekanik arıza veya motor problemleri ortaya çıkabilir. Bu tür durumlarda hızlı ve doğru müdahale yapılması sistemin tamamen bozulmasını engelleyebilir.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
                <h4 className="text-sm font-semibold text-gray-900 mb-3">Başlıca hizmet alanları:</h4>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Mafsallı tente sistemleri tamiri</span></li>
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Kasetli tente sistemleri bakımı</span></li>
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Motorlu tente tamiri</span></li>
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Tente kumaşı değişimi</span></li>
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Mekanik tente sistemleri onarımı</span></li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
                <h4 className="text-sm font-semibold text-gray-900 mb-3">Hizmet verdiğimiz mekanlar:</h4>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Konutlar ve apartmanlar</span></li>
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Kafeler ve restoranlar</span></li>
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Mağazalar ve işletmeler</span></li>
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Oteller ve tatil tesisleri</span></li>
                  <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Ofisler ve kurumsal binalar</span></li>
                </ul>
              </div>
            </div>
          </div>

          {/* H2 - Profesyonel Hizmet */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Profesyonel Tente Tamir Hizmeti Nasıl Olmalı?
            </h2>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Profesyonel bir <strong>tente tamiri izmir</strong> hizmeti, yalnızca arızayı gidermekle sınırlı değildir. Aynı zamanda sistemin genel durumunun değerlendirilmesi ve gelecekte oluşabilecek sorunların önlenmesi de önemlidir. Bu nedenle doğru ekipman ve uzmanlık gerektiren bir süreçtir.
            </p>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Profesyonel bir <strong>izmir tente tamir</strong> hizmetinde öncelikle sistem detaylı şekilde incelenir. Arızanın kaynağı tespit edildikten sonra uygun onarım yöntemi belirlenir. Bu sayede gereksiz parça değişimi veya maliyet oluşmasının önüne geçilebilir.
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <h4 className="text-sm font-semibold text-gray-900 mb-3">Profesyonel tamir sürecinde uygulanan adımlar:</h4>
              <ol className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start space-x-3"><span className="w-5 h-5 flex items-center justify-center bg-gray-900 text-white rounded-full text-xs flex-shrink-0 mt-0.5">1</span><span>Tente sisteminin detaylı incelenmesi</span></li>
                <li className="flex items-start space-x-3"><span className="w-5 h-5 flex items-center justify-center bg-gray-900 text-white rounded-full text-xs flex-shrink-0 mt-0.5">2</span><span>Arıza kaynağının tespit edilmesi</span></li>
                <li className="flex items-start space-x-3"><span className="w-5 h-5 flex items-center justify-center bg-gray-900 text-white rounded-full text-xs flex-shrink-0 mt-0.5">3</span><span>Uygun tamir yönteminin belirlenmesi</span></li>
                <li className="flex items-start space-x-3"><span className="w-5 h-5 flex items-center justify-center bg-gray-900 text-white rounded-full text-xs flex-shrink-0 mt-0.5">4</span><span>Parça değişimi veya mekanik ayar işlemleri</span></li>
                <li className="flex items-start space-x-3"><span className="w-5 h-5 flex items-center justify-center bg-gray-900 text-white rounded-full text-xs flex-shrink-0 mt-0.5">5</span><span>Son kontrol ve sistem testi</span></li>
              </ol>
            </div>
          </div>

          {/* H2 - Süre */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Profesyonel Tente Tamir Ne Kadar Sürer?
            </h2>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Tente tamir süresi, sistemde oluşan arızanın türüne göre değişiklik gösterebilir. Basit mekanik ayar işlemleri genellikle kısa sürede tamamlanabilir. Ancak motor arızası veya kumaş değişimi gibi işlemler biraz daha uzun sürebilir.
            </p>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Profesyonel bir <strong>tente tamiri izmir</strong> hizmetinde öncelikle arızanın detaylı şekilde incelenmesi gerekir. Yapılan analiz sonucunda tamir süresi hakkında daha net bir bilgi verilebilir.
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <h4 className="text-sm font-semibold text-gray-900 mb-3">Tamir süreci genel olarak şu şekilde ilerler:</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Arıza tespiti</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Gerekli ekipman ve parçaların hazırlanması</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Tamir işleminin uygulanması</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Sistem kontrolü ve test</span></li>
              </ul>
            </div>
          </div>

          {/* H2 - Fiyat */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              İzmir Tente Tamir Hizmet - Fiyat Listesi (2026 Güncel)
            </h2>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Tente tamir hizmetlerinde fiyatlar çeşitli faktörlere bağlı olarak değişiklik gösterebilir. Tente sisteminin modeli, arızanın türü ve kullanılacak parçalar fiyat üzerinde etkili olabilir. Bu nedenle her sistem için sabit bir fiyat belirlemek çoğu zaman mümkün değildir.
            </p>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Özellikle <strong>izmir tente sistemleri tamiri</strong> hizmetlerinde kullanılan parçaların kalitesi oldukça önemlidir. Kaliteli parçalar kullanıldığında sistem daha uzun süre sorunsuz şekilde kullanılabilir. Bu da uzun vadede maliyet avantajı sağlar.
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <h4 className="text-sm font-semibold text-gray-900 mb-3">Fiyatı etkileyen başlıca faktörler:</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Tente sisteminin modeli</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Arızanın kapsamı</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Parça değişimi gerekip gerekmediği</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Tente kumaşı durumu</span></li>
              </ul>
            </div>
          </div>

          {/* H2 - Bakım */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Tente Bakımı Nasıl Olmalı?
            </h2>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Tente sistemlerinin uzun ömürlü olması için düzenli bakım yapılması oldukça önemlidir. Zamanla biriken kir, toz ve dış etkenler tente mekanizmasının performansını olumsuz etkileyebilir. Bu nedenle belirli aralıklarla bakım yapılması tavsiye edilir.
            </p>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Özellikle açık alanlarda kullanılan tente sistemleri rüzgar ve güneş ışığına sürekli maruz kalır. Düzenli bakım sayesinde bu sorunların önüne geçmek mümkündür.
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <h4 className="text-sm font-semibold text-gray-900 mb-3">Tente bakımında dikkat edilmesi gerekenler:</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Mekanik parçaların düzenli kontrol edilmesi</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Tente kumaşının temiz tutulması</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Motorlu sistemlerde elektrik bağlantılarının kontrolü</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Rüzgarlı havalarda tente kullanımına dikkat edilmesi</span></li>
              </ul>
            </div>
          </div>

          {/* H2 - Her Model */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Her Tente Modeli Tamir Edilebilir Mi?
            </h2>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Tente sistemleri farklı model ve mekanik yapılarla üretilebilir. Mafsallı tenteler, kasetli tenteler ve motorlu sistemler en yaygın kullanılan modeller arasında yer alır. Bu sistemlerin büyük bir kısmı doğru müdahale ile tamir edilebilir.
            </p>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              Ancak bazı durumlarda sistemin tamamen değiştirilmesi gerekebilir. Özellikle çok eski veya ağır hasar görmüş tentelerde tamir yerine yenileme daha mantıklı bir çözüm olabilir. Bu kararın doğru şekilde verilmesi için sistemin detaylı incelenmesi gerekir.
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <h4 className="text-sm font-semibold text-gray-900 mb-3">Genel olarak tamir edilebilen sistemler:</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Mafsallı tente sistemleri</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Motorlu tente sistemleri</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Kasetli tente sistemleri</span></li>
                <li className="flex items-start space-x-2"><span className="w-1.5 h-1.5 bg-gray-800 rounded-full mt-2 flex-shrink-0"></span><span>Manuel tente mekanizmaları</span></li>
              </ul>
            </div>
          </div>

          {/* H2 - Nelere Dikkat */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              İzmir Tente Tamiri Yaptırırken Nelere Dikkat Edilmeli?
            </h2>
            <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
              <strong>İzmir tente tamir</strong> hizmeti alırken doğru firmayı seçmek hem maliyet hem de sistem güvenliği açısından büyük önem taşır. Tente sistemlerinde yapılacak yanlış bir müdahale, sistemin tamamen zarar görmesine neden olabilir.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-3">
                  <i className="ri-shield-check-line text-gray-700 text-lg"></i>
                </div>
                <h4 className="text-sm font-semibold text-gray-900 mb-2">Deneyim ve Uzmanlık</h4>
                <p className="text-xs text-gray-600">Tente sistemlerinde deneyimli ekip ile çalışın.</p>
              </div>
              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-3">
                  <i className="ri-money-dollar-circle-line text-gray-700 text-lg"></i>
                </div>
                <h4 className="text-sm font-semibold text-gray-900 mb-2">Şeffaf Fiyatlandırma</h4>
                <p className="text-xs text-gray-600">İşlem öncesinde net fiyat bilgisi alın, sürpriz maliyetlerden kaçının.</p>
              </div>
              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-3">
                  <i className="ri-tools-line text-gray-700 text-lg"></i>
                </div>
                <h4 className="text-sm font-semibold text-gray-900 mb-2">Kaliteli Malzeme</h4>
                <p className="text-xs text-gray-600">Uzun ömürlü kullanım için kaliteli yedek parça kullanımına dikkat edin.</p>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="mb-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Sık Sorulan Sorular
            </h2>
            <div className="space-y-4">
              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                <h3 className="text-sm font-bold text-gray-900 mb-2">Tente tamiri ne kadar sürer?</h3>
                <p className="text-sm text-gray-700">Tente arızasının türüne göre değişmekle birlikte çoğu tamir işlemi aynı gün içerisinde tamamlanabilir.</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                <h3 className="text-sm font-bold text-gray-900 mb-2">Tente kumaşı değiştirilebilir mi?</h3>
                <p className="text-sm text-gray-700">Evet. Yıpranan tente kumaşları profesyonel şekilde yenilenebilir.</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                <h3 className="text-sm font-bold text-gray-900 mb-2">Motorlu tente tamiri yapılabilir mi?</h3>
                <p className="text-sm text-gray-700">Motorlu tente sistemlerinde motor ve mekanik parçalar profesyonel ekip tarafından tamir edilebilir.</p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Stats Section */}
      <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#ede8e0' }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">Neden Biz</span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-1">Güvenilir ve Kaliteli Hizmet</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center rounded-xl p-4 md:p-6" style={{ backgroundColor: '#f4f1ec' }}>
                <div className="text-2xl md:text-4xl font-bold text-gray-900 mb-1">{stat.number}</div>
                <div className="text-xs text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* References Section */}
      <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#f4f1ec' }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">Referanslar</span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-1">Müşterilerimiz Ne Diyor?</h2>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {references.map((ref, index) => (
              <div key={index} className="rounded-xl p-4" style={{ backgroundColor: '#ede8e0' }}>
                <div className="text-gray-300 text-2xl mb-2">&ldquo;</div>
                <p className="text-xs text-gray-700 leading-relaxed mb-3">{ref.text}</p>
                <div className="flex items-center space-x-2">
                  <div className="w-7 h-7 flex items-center justify-center bg-gray-200 rounded-full">
                    <i className="ri-user-line text-xs text-gray-600"></i>
                  </div>
                  <div>
                    <strong className="text-xs text-gray-900 block">{ref.name}</strong>
                    <span className="text-xs text-gray-500">{ref.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Map & Contact Section */}
      <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#ede8e0' }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">Konum</span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-1">Bize Ulaşın</h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2 rounded-xl overflow-hidden w-full h-64 md:h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12520.0!2d27.1350!3d38.3750!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbd862e0e76b01%3A0x71e1bfb7e93dc000!2sKaraba%C4%9Flar%20Meydan%C4%B1!5e0!3m2!1str!2str!4v1704067200000!5m2!1str!2str"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="İzmir Tente Tamir Konum - Karabağlar İzmir"
              ></iframe>
            </div>
            <div className="rounded-xl p-6 flex flex-col justify-center" style={{ backgroundColor: '#f4f1ec' }}>
              <h3 className="text-lg font-bold text-gray-900 mb-4">İletişim Bilgileri</h3>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-gray-700"></i>
                  </div>
                  <div>
                    <span className="text-xs text-gray-500 block">Adres</span>
                    <span className="text-sm text-gray-900">Karabağlar / İzmir</span>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-gray-700"></i>
                  </div>
                  <div>
                    <span className="text-xs text-gray-500 block">Telefon</span>
                    <a href="tel:+905513723512" className="text-sm text-gray-900 hover:text-gray-700 cursor-pointer">0551 372 35 12</a>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-lg flex-shrink-0">
                    <i className="ri-whatsapp-line text-green-600"></i>
                  </div>
                  <div>
                    <span className="text-xs text-gray-500 block">WhatsApp</span>
                    <a
                      href={`https://wa.me/905513723512?text=${whatsappMessage}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-gray-900 hover:text-gray-700 cursor-pointer"
                    >
                      WhatsApp ile Yaz
                    </a>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-gray-700"></i>
                  </div>
                  <div>
                    <span className="text-xs text-gray-500 block">Çalışma Saatleri</span>
                    <span className="text-sm text-gray-900">09:00 - 17:00</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#f4f1ec' }}>
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-xl md:text-2xl text-gray-900 leading-relaxed mb-6">
            <span className="font-light italic text-gray-600">Tenteleriniz için</span>{' '}
            <strong className="font-bold">profesyonel çözüm</strong>{' '}
            <span className="font-light italic text-gray-600">mü arıyorsunuz?</span>
          </p>
          <a
            href="tel:+905513723512"
            className="inline-block px-8 py-3 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Ücretsiz Keşif İçin Ara
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
